import { Button, Card, CardContent, CardHeader, CardTitle, FormField, Input } from "@jod/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import type { FormEvent } from "react";
import { useState } from "react";
import { verifyPlatformToken } from "../features/platform/api.ts";
import { signInPlatform } from "../lib/auth-session.ts";

export const Route = createFileRoute("/login")({ component: LoginScreen });

function LoginScreen() {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isVerifying, setIsVerifying] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    const candidate = token.trim();
    if (!candidate) {
      setError("Enter your operator access token.");
      return;
    }
    setIsVerifying(true);
    setError(null);
    try {
      const me = await verifyPlatformToken(candidate);
      signInPlatform(candidate, {
        operatorId: me.operatorId,
        email: me.email,
        role: me.role,
      });
      void navigate({ to: "/dashboard" });
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Sign in failed.");
    } finally {
      setIsVerifying(false);
    }
  }

  return (
    <div className="grid min-h-dvh place-items-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="font-display text-2xl">Platform Backoffice</CardTitle>
          <p className="text-muted-foreground text-sm">
            Internal operator console — venue onboarding, oversight, audit.
          </p>
        </CardHeader>
        <CardContent>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <FormField
              id="token"
              label="Operator access token"
              hint="Issued by a super admin. Every action is audited."
            >
              <Input
                id="token"
                type="password"
                autoComplete="off"
                value={token}
                onChange={(event) => setToken(event.target.value)}
              />
            </FormField>
            {error ? (
              <p role="alert" className="rounded-md bg-destructive/10 p-3 text-destructive text-sm">
                {error}
              </p>
            ) : null}
            <Button type="submit" className="w-full" disabled={isVerifying}>
              {isVerifying ? "Verifying…" : "Sign in"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
